module.exports = __webpack_public_path__ + "img/se.d46dbac2.svg";